import { Component } from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InvocingService } from '../../services/invocing.service';
import { forkJoin, catchError, of } from 'rxjs';
import { LoaderComponent } from "../../utils/loader/loader.component";
import { SecuenceConsumption } from '../../models/SecuenceConsumption';
import { InvoiceComponent } from "../../utils/invoice/invoice.component";
import { ProfileServicesService } from '../../services/profile-services.service';
import { ProfileModel } from '../../models/ProfileModel';
import { CommonModule } from '@angular/common';
import { invoiceData } from '../../models/invoiceData';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { ContactInfo, ContactInfoService } from '../../services/contact-info.service';

@Component({
    selector: 'app-invoicing',
    imports: [DatePickerModule, LoaderComponent, InvoiceComponent, CommonModule, FormsModule, ToggleSwitchModule, ButtonModule],
    templateUrl: './invoicing.component.html',
    styleUrl: './invoicing.component.scss'
})
export class InvoicingComponent {
  results = [];
  searched = false;
  regular = true;
  premium = true;
  diesel = true;
  today= new Date();
  minDate = new Date(this.today.getFullYear(),this.today.getMonth(),1);
  maxDate = this.today
  selectedDate = new Date();
  tokenAuth: any;
  data: any;
  isChecked = false;
  clientProfile!: any;
  station: any;
  tokenInvoice: any;
  isLoading = false;
  taxRate16List: SecuenceConsumption[] = [];
  taxRate8List: SecuenceConsumption[] = [];
  invoices: invoiceData[] = [];
  msgLoader = 'Buscando';
  responseInvoice: any;
  isError = false;
  titleError = '';
  suggestedActions: any[] = [];
  isDataError = false;
  isSuccess = false;


  msgErrroConsumptionSearched = "No hay consumos por facturar";
  isInvoiced = false;
  contact!: ContactInfo;
  constructor(private service: InvocingService, private profileService: ProfileServicesService, private titleService:Title,private themeService:ThemeService,
    private contactSvc: ContactInfoService
  ) {
    
    this.themeService.setTitle("Facturación");
    this.titleService.setTitle("Facturación")

    this.data = JSON.parse(localStorage.getItem('data')!);
    this.contactSvc.get().subscribe(c => this.contact = c);
  }

  changeDate(date: any) {
    this.selectedDate = date;
  }


  searchInvoices() {
    this.isLoading = true;
    this.msgLoader = 'Buscando';
    this.isDataError = false;
    this.titleError = '';
    this.taxRate16List = [];
    this.taxRate8List = [];

    forkJoin({
      station: this.service.getStationInvoice().pipe(catchError(() => of(null))),
      consumptions: this.service.getListInvoice(this.selectedDate, this.data.Client_number, this.data.Name, this.regular, this.premium, this.diesel, '123').pipe(catchError(() => of(null))),
      profile: this.clientProfile ? of(this.clientProfile) : this.service.loadDataFiscal(this.data.Client_number).pipe(catchError(() => of(null)))
    }).subscribe({
      next: ({ station, consumptions, profile }) => {
        this.isLoading = false;
        this.searched = true;

        if (!station) {
          this.msgErrroConsumptionSearched = 'No pudimos contactar al servicio de facturación, intente de nuevo o comuníquese con atención a clientes';
          return;
        }
        this.station = station;
        this.clientProfile = profile;

        if (!consumptions?.listSecuence) {
          this.msgErrroConsumptionSearched = 'Hubo un problema interno, intenta de nuevo o comuníquese con atención a clientes';
          return;
        }

        if (consumptions.listSecuence.length === 0) {
          this.msgErrroConsumptionSearched = consumptions.message;
          return;
        }

        consumptions.listSecuence.forEach((row: any) => {
          if (parseInt(row.tax) === 16) this.taxRate16List.push(row);
          else if (parseInt(row.tax) === 8) this.taxRate8List.push(row);
        });
        this.msgErrroConsumptionSearched = consumptions.message;
      },
      error: () => {
        this.isLoading = false;
        this.searched = true;
        this.msgErrroConsumptionSearched = 'No hay consumos por facturar';
      }
    });
  }

  loadProfileClient() {
    this.service.loadDataFiscal(this.data.Client_number).subscribe({
      next: (data: any) => {
        this.clientProfile = data;
      },
      error: (err: any) => {
        this.clientProfile = null;
      }
    });


  }


  clickInvoice() {
    this.isLoading = true;
    this.msgLoader = 'Generando';
     this.doInvoice('');
  }

  doInvoice(token: string) {
    this.titleError = '';
    this.isError = false;
    this.isDataError=false;
    this.isSuccess=false;
    this.msgLoader = 'Generando Factura';
    this.service.invoiceConsumptions(this.selectedDate, this.data.Client_number, this.data.Name, this.regular, this.premium, this.diesel, token).subscribe({
      next: (resp: any) => {
        
        this.isLoading = false;
        if (resp.listInvoice.length > 0) {
          this.isSuccess = true;
          this.isInvoiced = true;
          this.responseInvoice = resp;
          this.invoices = resp.Listinvoice;
         
        } else {
          if (resp.message.includes('DomicilioFiscalReceptor')) {
            this.titleError = 'El domicilio fiscal en sistema no coincide con el domicilio fiscal registrado en el SAT para el RFC del receptor.';
            this.suggestedActions = [{
              short: "Actualizar Código Postal",
              long: "Puede actualizar el código postal directamente desde la vista preliminar de la factura.",
            },
            {
              short: "Actualizar otros datos fiscales",
              long: "Si necesita realizar otros cambios en sus datos fiscales, envíe su Constancia de Situación Fiscal a " + (this.contact?.emails?.invoicing || 'facturamonedero@xiga.com.mx') + " para actualizar la información en el sistema.",
            }];
            this.isDataError = true;
           // this.isError=true;
          } else {
            this.titleError = resp.message;
            this.isError = true;
          }
        }
      },
      error: (resp: any) => {
        this.isLoading = false;
        this.titleError = 'Error de facturación. Contactar con Atención a Clientes.';
        this.isError = true;
      }
    });
  }




}
